import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import "./servicioenlinea.css"
import Header from "../../components/header"
import Footer from "../../components/footer"
import Seo from "../../components/seo"
import Accesibilidad from "../../components/accesibilidad"

const Procesoservicioenlinea = props => {
  let id_recortado = props.location.search.slice(4)

  const query = useStaticQuery(graphql`
    query Procesoservicioenlinea {
      allStrapiServicioOnlines {
        edges {
          node {
            id
            Titulo
            Contenido
            Enlace_externo
            Orden
            Icono {
              url
            }
          }
        }
      }
    }
  `)
  const projects = query.allStrapiServicioOnlines.edges

  return (
    <>
      <Accesibilidad />
      <Header site="personas" />

      <Seo />

      {/* <div className="mitexto mitexto_color"> */}
      {projects.map(({ node: project }) => {
        if (project.id === id_recortado) {
          return (
            <div className="mitexto">
              {!localStorage.getItem("contraste_accesibilidad") && (
                <div
                  className="text-poppins-regular color-texto-parrafo"
                  layout="fullWidth"
                  dangerouslySetInnerHTML={{ __html: project.Contenido }}
                ></div>
              )}

              {localStorage.getItem("contraste_accesibilidad") && (
                <div
                  // className="dark mitexto_color_dos pb-4"
                  className="mitexto_color_dos pb-4"
                  layout="fullWidth"
                  dangerouslySetInnerHTML={{ __html: project.Contenido }}
                ></div>
              )}
              {!localStorage.getItem("contraste_accesibilidad") && (
                <div className="w-3/4 mx-auto pb-20 mitexto margen_detalle_servicio_linea_texto">
                  <iframe
                    className="alto_iframe_servicio_linea"
                    src={project.Enlace_externo}
                    frameborder="0"
                  ></iframe>
                </div>
              )}

              {localStorage.getItem("contraste_accesibilidad") && (
                <div className="w-3/4 mx-auto pb-20 mitexto margen_detalle_servicio_linea_texto">
                  <iframe
                    // className="dark alto_iframe_servicio_linea"
                    className="alto_iframe_servicio_linea"
                    src={project.Enlace_externo}
                    frameborder="0"
                  ></iframe>
                </div>
              )}
            </div>
          )
        }
      })}
      {/* </div> */}
      <Footer />
    </>
  )
}

Procesoservicioenlinea.propTypes = {
  siteTitle: PropTypes.string,
}

Procesoservicioenlinea.defaultProps = {
  siteTitle: ``,
}

export default Procesoservicioenlinea
